import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getToken } from "../../utils/tokenStorage";
import { url } from "../../utils/config";
import { serverMessage } from "../../utils/serverMessage";
import { toast } from "react-toastify";
import { delayMessage } from "../../utils/delayMessage";

interface SaveLater {
  isCreateSaveForLaterLoading: boolean;
  pendingRequestTimer: any;
}

const initialState: SaveLater = {
  isCreateSaveForLaterLoading: false,
  pendingRequestTimer: null,
};

export const createSaveLaterAction = createAsyncThunk(
  "createSaveLater",
  async (details: any, thunkAPI) => {
    try {
      const { _id, ...rest }: any = details;
      const token = getToken();
      const { data } = await axios.post(
        `${url.baseUrl}/saveForLater/${_id}`,
        rest,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //   console.log(data);
      return data;
    } catch (error: any) {
      console.log(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const createSaveForLaterSlice = createSlice({
  name: "saveForLater",
  initialState,
  reducers: {
    //
  },

  extraReducers: (builder) => {
    builder
      .addCase(createSaveLaterAction.pending, (state) => {
        state.isCreateSaveForLaterLoading = true;
        // Start a timer to show toast message if request is still pending after 10 seconds
        state.pendingRequestTimer = setTimeout(delayMessage, 10000);
      })
      .addCase(createSaveLaterAction.fulfilled, (state) => {
        state.isCreateSaveForLaterLoading = false;
        toast.success("Job saved for later successfully");
        // Clear timeout
        state.pendingRequestTimer && clearTimeout(state.pendingRequestTimer);
      })
      .addCase(createSaveLaterAction.rejected, (state, { payload }: any) => {
        state.isCreateSaveForLaterLoading = false;
        serverMessage(payload);
        // Clear timeout
        state.pendingRequestTimer && clearTimeout(state.pendingRequestTimer);
      });
  },
});

export default createSaveForLaterSlice.reducer;
